<!-- <div [brManageMenuButton]="menu"></div> -->

<mflooring-layout-wrapper
  [content]="layoutContainerProp.content"
  [presentation]="layoutContainerProp.presentation"
  >
  <div class="utility-container" [ngClass]="pageTitleVisDemo">
    @if (menu && menu?.siteMenuItems.length) {
      @if (!isMobile) {
        <mflooring-utility-desktop
          class="menu-desktop"
          [openedMenu]="openedMenu"
          [menu]="menu"
          [page]="page"
          (openMenu)="openMenu($event)"
          (closeMenu)="closeMenu()"
        ></mflooring-utility-desktop>
      }
      @if (isMobile) {
        <mflooring-utility-mobile
          class="menu-mobile"
          [openedMenu]="openedMenu"
          [menuFlatted]="menuFlatted"
          [page]="page"
          (openMenu)="openMenu($event)"
          (closeMenu)="closeMenu()"
        ></mflooring-utility-mobile>
      }
    }

    <!-- <mflooring-utility-actions
    [content]="utilityHeaderData$ | async"
    class="menu-utility--right"
  ></mflooring-utility-actions> -->
</div>
</mflooring-layout-wrapper>
